import React from "react";
import styles from "./style.scss";

export const Pre = ({ children }) => {
    return <pre className={styles.base}>{children}</pre>;
};
